import React from 'react';
import clsx from 'clsx';
import { hasErrorCode } from '@/utils/errors';
import errorCodes from '@/constants/errors';
import NotAuthorised from '@/components/errors/NotAuthorised';
import { fetchRequests, toggleRequestSelected, toggleRequestsPresentation } from '../actions';

const RequestsPanelContainer = ({
  readErrors,
  canRead,
  className,
  children,
}) => {
  if (!canRead || hasErrorCode(readErrors, errorCodes.forbidden)) {
    return <NotAuthorised />;
  }

  return (
    <div className={clsx('aridhia-requests-panel-container', className)}>
      { children }
    </div>
  );
};

export const mapStateToProps = ({
  requests: { requests, allowPmnTransfer, newRequestCode },
  auth: { role: { permissions } },
}, { category, displayAs }) => {
  const {
    currentPage, display, totalPages, pageSize, readErrors, readStatus, results, reviewFlag, count,
  } = requests[category];

  return {
    allowPmnTransfer,
    canRead: permissions.requests.read,
    canCreate: permissions.requests.create,
    display: displayAs || display,
    currentPage,
    newRequestCode,
    pageCount: totalPages,
    pageSize,
    readErrors,
    readStatus,
    requests: results,
    review: reviewFlag,
    total: count,
  };
};

export const mapDispatchToProps = {
  fetchData: fetchRequests,
  onCheckBoxClick: toggleRequestSelected,
  togglePresentation: toggleRequestsPresentation,
};

export default RequestsPanelContainer;
